module.exports = __webpack_public_path__ + "img/9F4738_CE958D_4F0C0A_C0837C-256px.4437b6a8.png";